<template>
	<div class="annualPlan workTask">
		<div class="wx_title"><span>工作任务</span></div>
		<div class="select_year">
			<span class="label">选择年份:</span>
			<el-date-picker v-model="year" type="year" format="yyyy 年" value-format="yyyy" size="mini" placeholder="选择年"
				@change="getFarmWorkTask">
			</el-date-picker>
		</div>
		<div class="tabs">
<span :class="{'active':tabShowNum==100}" @click="changeTaskTab(100)" v-if="user_position_code==200 || user_position_code==100">预排任务</span>
			<span :class="{'active':tabShowNum==200}" @click="changeTaskTab(200)" v-if="user_position_code==150">待审核任务</span>
			<span :class="{'active':tabShowNum==300}" @click="changeTaskTab(300)" v-if="user_position_code<300">待分配任务</span>
<!-- 		<span :class="{'active':tabShowNum==100}" @click="changeTaskTab(100)">预排任务</span>
			<span :class="{'active':tabShowNum==200}" @click="changeTaskTab(200)">待审核任务</span>
			<span :class="{'active':tabShowNum==300}" @click="changeTaskTab(300)">待分配任务</span> -->
			<span :class="{'active':tabShowNum==400}" @click="changeTaskTab(400)">进行中任务</span>
			<span :class="{'active':tabShowNum==500}" @click="changeTaskTab(500)">已结束任务</span>
		</div>
		<div v-if="taskZnTableData.length>0">
		<div class="tabTop">
			<h4 class="subTitle">诊断任务</h4>
		</div>
		<div class="tabTop">
			<div class="select_box">
				<el-select v-model="tabZnPage.area_id" placeholder="全部分区" size="medium" @change="changeZnArea" clearable>
					<el-option v-for="item in partition_list" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="tabZnPage.crop_id" placeholder="作物品种列表" size="medium" @change="changeZnCrop" clearable>
					<el-option v-for="item in crop_list" :key="item.id" :label="item.crop_name"
						:value="item.crop_id">
					</el-option>
				</el-select>
				<el-select v-model="tabZnPage.type_id" placeholder="任务类别" size="medium" @change="changeZnTaskType" clearable>
					<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-if="tabShowNum == 4" v-model="tabZnPage.task_complete_status" placeholder="任务结束状态"
					size="medium" @change="changeZnCompleteStatus" clearable>
					<el-option v-for="item in endStateList" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="btn_box" v-if="tabShowNum == 100" style="display: none;">
				<el-button @click="addTaskShow = true">添加任务</el-button>
			</div>
		</div>
		<el-table :data="taskZnTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
			key="tab10" @selection-change="handleSelectionChange" v-if="tabShowNum == 100">
			<el-table-column type="selection" width="50"></el-table-column>
			<!-- <el-table-column prop="id" label="id" width="130"></el-table-column> -->
			<el-table-column prop="display_run_time" label="执行时间" width="120"></el-table-column>
			<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
			<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
			<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
			<el-table-column prop="task_name" label="任务名" min-width="130"></el-table-column>
			<el-table-column prop="task_remark" label="任务操作说明" width="460"></el-table-column>
			<el-table-column label="操作" width="270">
				<template slot-scope="scope">
					<el-button class="edit_btn" type="primary" plain size="small"
						@click="EditWorkTask(scope.row.id)">编辑</el-button>
					<el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">
						删除</el-button>
					<el-button class="detail_btn" type="danger" plain size="small"
						@click="handlePublish(scope.row.id)">发布</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination disFlex" v-if="tabShowNum == 100">
			<div class="pagination_btn">
				<el-button @click="releaseAllShow = true">批量发布</el-button>
				<el-button @click="delAllShow = true">批量删除</el-button>
			</div>
		</div>
		<el-table :data="taskZnTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
			key="tab100" @selection-change="handleZnSelectionChange" v-if="tabShowNum == 200">
			<el-table-column type="selection" width="50"></el-table-column>
			<el-table-column prop="id" label="id" width="130"></el-table-column>
			<el-table-column prop="display_run_time" label="任务执行时间"></el-table-column>
			<el-table-column prop="area.name" label="任务执行分区"></el-table-column>
			<el-table-column prop="crop_name" label="作物品种"></el-table-column>
			<el-table-column prop="type_name" label="任务类别"></el-table-column>
			<el-table-column prop="task_name" label="任务名"></el-table-column>
			<el-table-column prop="task_remark" label="任务操作说明" width="460"></el-table-column>
			<el-table-column label="审核状态" width="270">
				<template slot-scope="scope">
					<span v-if="scope.row.is_check==2">审核中</span>
					<span v-else>审核拒绝</span>
		
				</template>
			</el-table-column>
			<el-table-column label="操作" width="270">
				<template slot-scope="scope">
					<!--          <el-button class="edit_btn" type="primary" plain size="small"  @click="EditWorkTask(scope.row.id)">编辑</el-button>
		    <el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">删除</el-button> -->
					<el-button class="detail_btn" type="danger" plain size="small"
						@click="EditWorkTask(scope.row.id)">审核</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination disFlex" v-if="tabShowNum == 200">
			<div class="pagination_btn">
				<!-- <el-button @click="releaseAllShow = true">批量审核</el-button> -->
		<el-button @click="checkShow = true">批量审核</el-button>
			</div>
		</div>
		<el-table :data="taskZnTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
			key="tab20" @selection-change="handleZnSelectionChange" v-if="tabShowNum == 300">
			<el-table-column type="selection" width="50"></el-table-column>
			<el-table-column prop="id" label="id" width="130"></el-table-column>
			<el-table-column prop="display_run_time" label="任务执行时间"></el-table-column>
			<el-table-column prop="area.name" label="任务执行分区"></el-table-column>
			<el-table-column prop="crop_name" label="作物品种"></el-table-column>
			<el-table-column prop="type_name" label="任务类别"></el-table-column>
			<el-table-column prop="task_name" label="任务名"></el-table-column>
			<!-- <el-table-column prop="created_at" label="任务发布时间" width="174"></el-table-column> -->
			<el-table-column prop="task_remark" label="任务操作说明" width="460"></el-table-column>
			<el-table-column label="操作" width="270">
				<template slot-scope="scope">
					<el-button class="edit_btn" type="primary" plain size="small"
						@click="EditWorkTask(scope.row.id)">查看</el-button>
					<el-button class="detail_btn" type="danger" plain size="small" @click="planTask(scope.row.id)"
						v-if="user_position_code==200">安排</el-button>
				</template>
			</el-table-column>
		</el-table>
		<div class="pagination disFlex" v-if="tabShowNum == 300 && user_position_code==200">
			<div class="pagination_btn">
				<el-button @click="personnelShow = true">批量安排</el-button>
			</div>
		</div>
		
		<el-table :data="taskZnTableData" class="wx_table" :row-class-name="tableRowClassName" key="tab30"
			@selection-change="handleZnSelectionChange" v-if="tabShowNum == 400">
			<el-table-column prop="id" label="id" width="130"></el-table-column>
			<el-table-column prop="display_run_time" label="任务执行时间" width="140"></el-table-column>
		
			<el-table-column prop="area.name" label="任务执行分区" width="130"></el-table-column>
			<el-table-column prop="crop_name" label="作物品种"></el-table-column>
			<el-table-column prop="type_name" label="任务类别"></el-table-column>
			<el-table-column prop="task_name" label="任务名"></el-table-column>
			<!-- <el-table-column prop="created_at" label="任务发布时间" width="174"></el-table-column> -->
			<el-table-column prop="plan_task_time" label="任务安排时间" width="174"></el-table-column>
			<el-table-column prop="user_name" label="填写人员"></el-table-column>
			<el-table-column prop="day_number" label="任务已执行天数" width="120"></el-table-column>
			<el-table-column prop="state" label="任务进行状态" width="110">
				<template slot-scope="scope">
					<span v-if="scope.row.task_status==200" style="color: #FF420C;">待填写</span>
					<span v-else-if="scope.row.task_status==300" style="color: #FF420C;">待审核</span>
					<span v-else-if="scope.row.task_status==400" style="color: #FF420C;">已完成</span>
		
				</template>
			</el-table-column>
			<el-table-column label="操作" prop="" width="134">
				<template slot-scope="scope">
					<el-button v-if="scope.row.task_status==200" class="edit_btn" type="primary" plain size="small"
						@click="EditWorkTask(scope.row.id)">填写任务</el-button>
					<el-button v-else class="edit_btn" type="primary" plain size="small"
						@click="EditWorkTask(scope.row.id)">查 看</el-button>
				</template>
			</el-table-column>
		</el-table>
		
		<!--        已结束任务-->
		
		<el-table :data="taskZnTableData" class="wx_table" :row-class-name="tableRowClassName" key="tab40"
			@selection-change="handleZnSelectionChange" v-if="tabShowNum ==500">
		
			< <el-table-column prop="display_run_time" label="任务执行时间" width="140">
				</el-table-column>
		
				<el-table-column prop="area.name" label="任务执行分区" width="130"></el-table-column>
				<el-table-column prop="crop_name" label="作物品种"></el-table-column>
				<el-table-column prop="type_name" label="任务类别"></el-table-column>
				<el-table-column prop="task_name" label="任务名"></el-table-column>
			<!-- 	<el-table-column prop="created_at" label="任务发布时间" width="174"></el-table-column> -->
				<el-table-column prop="plan_task_time" label="任务安排时间" width="174"></el-table-column>
				<el-table-column prop="complete_time" label="任务结束时间" width="174"></el-table-column>
				<el-table-column prop="day_number" label="任务已执行天数" width="120"></el-table-column>
				<el-table-column prop="state" label="任务进行状态" width="110">
					<template slot-scope="scope">
						<span v-if="scope.row.task_complete_status==1">任务完成</span>
						<span v-else style="color: #FF420C;">任务取消</span>
					</template>
				</el-table-column>
				<el-table-column label="操作" prop="" width="100">
					<template slot-scope="scope">
						<el-button class="edit_btn" type="primary" plain size="small"
							@click="EditWorkTask(scope.row.id)">详情</el-button>
							
					</template>
				</el-table-column>
		</el-table>
		<div class="pagination">
			<el-pagination @size-change="handleZnSizeChange" @current-change="handleZnCurrentChange"
				:current-page="tabZnPage.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="tabZnPage.pagesize"
				:total="zn_total"></el-pagination>
		</div>
		</div>
		<div class="tabTop">
			<!-- <div class="select_box">
				<el-button style="background-color: #10F5C3; border: 0;">常规任务</el-button>

			</div> -->
			<h4 class="subTitle">常规任务</h4>
		</div>
		<div class="tabTop">
			<div class="select_box">
				<el-select v-model="tabPage.area_id" placeholder="全部分区" size="medium" @change="changeArea" clearable>
					<el-option v-for="item in partition_list" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-model="tabPage.crop_id" placeholder="作物品种列表" size="medium" @change="changeCrop" clearable>
					<el-option v-for="item in crop_list" :key="item.id" :label="item.crop_name"
						:value="item.crop_id">
					</el-option>
				</el-select>
				<el-select v-model="tabPage.type_id" placeholder="任务类别" size="medium" @change="changeTaskType" clearable>
					<el-option v-for="item in typeList" :key="item.id" :label="item.name" :value="item.id">
					</el-option>
				</el-select>
				<el-select v-if="tabShowNum == 4" v-model="tabPage.task_complete_status" placeholder="任务结束状态"
					size="medium" @change="changeCompleteStatus" clearable>
					<el-option v-for="item in endStateList" :key="item.id" :label="item.value" :value="item.id">
					</el-option>
				</el-select>
			</div>
			<div class="btn_box" v-if="tabShowNum == 100 ">
				<el-button @click="addTaskShow = true,taskForm['is_publish']=2">添加任务</el-button>
			</div>
			<div class="btn_box" v-if="tabShowNum == 200 ">
				<el-button @click="addTaskShow = true,taskForm['is_publish']=1">添加任务</el-button>
			</div>
			<div class="btn_box"  v-if="tabShowNum == 500 && (user_position_code==150 || user_position_code==200)" >
				<el-button @click="one_key_task()">已完成当日任务</el-button>
			</div>
		</div>
		<!--        预排任务-->
		<template>
			<el-table :data="taskTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
				key="tab1" @selection-change="handleSelectionChange" v-if="tabShowNum == 100">
				<el-table-column type="selection" width="50"></el-table-column>
				<!-- <el-table-column prop="id" label="id" width="130"></el-table-column> -->
				<el-table-column prop="display_run_time" label="执行时间" width="120"></el-table-column>
				<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
				<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
				<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
				<el-table-column prop="task_name" label="任务名" width="300"></el-table-column>
				<el-table-column prop="task_remark" label="任务操作说明" min-width="130"></el-table-column>
				<el-table-column label="操作" width="270">
					<template slot-scope="scope">
						<el-button class="edit_btn" type="primary" plain size="small"
							@click="EditWorkTask(scope.row.id)">编辑</el-button>
						<el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">
							删除</el-button>
						<el-button class="detail_btn" type="danger" plain size="small"
							@click="handlePublish(scope.row.id)">发布</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination disFlex" v-if="tabShowNum == 100">
				<div class="pagination_btn">
					<el-button @click="releaseAllShow = true">批量发布</el-button>
					<el-button @click="delAllShow = true">批量删除</el-button>
				</div>
			</div>
			<el-table :data="taskTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
				key="tab1" layout="total, sizes, prev, pager, next, jumper" @selection-change="handleSelectionChange" v-if="tabShowNum == 200">
				<el-table-column type="selection" width="50"></el-table-column>
				<!-- <el-table-column prop="id" label="id" width="130"></el-table-column> -->
				<el-table-column prop="display_run_time" label="执行时间" width="120"></el-table-column>
				<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
				<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
				<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
				<el-table-column prop="task_name" label="任务名" width="300"></el-table-column>
				<el-table-column prop="task_remark" label="任务操作说明" min-width="130"></el-table-column>
				<el-table-column label="审核状态" width="130">
					<template slot-scope="scope">
						<span v-if="scope.row.is_check==2">审核中</span>
						<span v-else>审核拒绝</span>

					</template>
				</el-table-column>
				<el-table-column label="操作" width="100">
					<template slot-scope="scope">
						<!--          <el-button class="edit_btn" type="primary" plain size="small"  @click="EditWorkTask(scope.row.id)">编辑</el-button>
                <el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">删除</el-button> -->
				<el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">
					删除</el-button>
						<el-button class="detail_btn" type="danger" plain size="small"
							@click="EditWorkTask(scope.row.id)" >审核</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination disFlex" v-if="tabShowNum == 200">
				<div class="pagination_btn">
					<el-button @click="checkShow = true">批量审核</el-button>
				</div>
			</div>
			<el-table :data="taskTableData" class="wx_table transparent_tab" :row-class-name="tableRowClassName"
				key="tab2" @selection-change="handleSelectionChange" v-if="tabShowNum == 300">
				<el-table-column type="selection" width="50"></el-table-column>
				<!-- <el-table-column prop="id" label="id" width="130"></el-table-column> -->
				<el-table-column prop="display_run_time" label="执行时间" width="120"></el-table-column>
				<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
				<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
				<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
				<el-table-column prop="task_name" label="任务名" width="300"></el-table-column>
			<!-- 	<el-table-column prop="created_at" label="发布时间" width="120"></el-table-column> -->
				<el-table-column prop="task_remark" label="任务操作说明" min-width="110"></el-table-column>
				<el-table-column label="操作" width="200">
					<template slot-scope="scope">
						<el-button class="del_btn" type="danger" plain size="small" @click="handleDelete(scope.row.id)">
							删除</el-button>
						<el-button class="edit_btn" type="primary" plain size="small"
							@click="EditWorkTask(scope.row.id)">查看</el-button>
						<el-button class="detail_btn" type="danger" plain size="small" @click="planTask(scope.row.id)"
							v-if="user_position_code==200">安排</el-button>
					</template>
				</el-table-column>
			</el-table>
			<div class="pagination disFlex" v-if="tabShowNum == 300 && user_position_code==200">
				<div class="pagination_btn">
					<el-button @click="personnelShow = true">批量安排</el-button>
				</div>
			</div>

			<el-table :data="taskTableData" class="wx_table" :row-class-name="tableRowClassName" key="tab3"
				@selection-change="handleSelectionChange" v-if="tabShowNum == 400">
				<!-- <el-table-column prop="id" label="id" width="130"></el-table-column> -->
				<el-table-column prop="display_run_time" label="执行时间" width="120"></el-table-column>

				<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
				<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
				<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
				<el-table-column prop="task_name" label="任务名" min-width="130"></el-table-column>
			<!-- 	<el-table-column prop="created_at" label="发布时间" width="120"></el-table-column> -->
				<el-table-column prop="plan_task_time" label="安排时间" width="120"></el-table-column>
				<el-table-column prop="user_name" label="填写人员" width="110"></el-table-column>
				<el-table-column prop="day_number" label="已执行天数" width="120"></el-table-column>
				<el-table-column prop="state" label="进行状态" width="110">
					<template slot-scope="scope">
						<span v-if="scope.row.task_status==200" style="color: #FF420C;">待填写</span>
						<span v-else-if="scope.row.task_status==300" style="color: #FF420C;">待审核</span>
						<span v-else-if="scope.row.task_status==400" style="color: #FF420C;">已完成</span>

					</template>
				</el-table-column>
				<el-table-column label="操作" prop="" width="100">
					<template slot-scope="scope">
						<el-button v-if="scope.row.task_status==200" class="edit_btn" type="primary" plain size="small"
							@click="EditWorkTask(scope.row.id)">填写</el-button>
						<el-button v-else class="edit_btn" type="primary" plain size="small"
							@click="EditWorkTask(scope.row.id)">查 看</el-button>
					</template>
				</el-table-column>
			</el-table>

			<!--        已结束任务-->

			<el-table :data="taskTableData" class="wx_table" :row-class-name="tableRowClassName" key="tab4"
				@selection-change="handleSelectionChange" v-if="tabShowNum ==500">

				< <el-table-column prop="display_run_time" label="执行时间" width="120">
					</el-table-column>

					<el-table-column prop="area.name" label="执行分区" width="110"></el-table-column>
					<el-table-column prop="crop_name" label="作物品种" width="110"></el-table-column>
					<el-table-column prop="type_name" label="任务类别" width="110"></el-table-column>
					<el-table-column prop="task_name" label="任务名" min-width="130"></el-table-column>
					<!-- <el-table-column prop="created_at" label="发布时间" width="124"></el-table-column> -->
					<el-table-column prop="plan_task_time" label="安排时间" width="124"></el-table-column>
					<el-table-column prop="complete_time" label="结束时间" width="124"></el-table-column>
					<el-table-column prop="day_number" label="已执行天数" width="120"></el-table-column>
					<el-table-column prop="state" label="进行状态" width="110">
						<template slot-scope="scope">
							<span v-if="scope.row.task_complete_status==1">完成状态</span>
							<span v-else style="color: #FF420C;">任务取消</span>
						</template>
					</el-table-column>
					<el-table-column label="操作" prop="" width="100">
						<template slot-scope="scope">
							<el-button class="edit_btn" type="primary" plain size="small"
								@click="EditWorkTask(scope.row.id)">详情</el-button>
								<!-- <el-button class="edit_btn" type="primary" plain size="small"
									@click="updateWorkTask(scope.row.id)">更改时间</el-button> -->
						</template>
					</el-table-column>
			</el-table>
			<div class="pagination">
				<el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange"
					:current-page="tabPage.currentPage" :page-sizes="[10, 20, 30, 40]" :page-size="tabPage.pagesize"
					:total="total" layout="total, sizes, prev, pager, next, jumper"></el-pagination>
			</div>
		
			<Comment :farm_id="farm_id" :user="user" ref="comment" v-if="tabShowNum>=400"></Comment>
		</template>
		<template>

		</template>
		<!--        弹窗-->
		<!--        发布-->
		<WxMessageBox :show="releaseShow" @save="releaseSave" @canse="releaseCanse">
			<div slot="content">
				<div class="word marTop">
					<p>您想发布的任务，执行时间已过，是否</p>
					<p>直接调整为今日执行？如果想调整其他</p>
					<p>日期，请点击编辑按钮。</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        批量发布-->
		<WxMessageBox :show="releaseAllShow" @save="releaseAllSave" @canse="releaseAllCanse">
			<div slot="content">
				<div class="word">
					<p>您确认要批量发布勾选的任务么？</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        批量发布判断-->
		<WxMessageBox :show="releaseAllJudgeShow" @save="releaseAllJudgeSave" @canse="releaseAllJudgeCanse">
			<div slot="content">
				<div class="word marTop">
					<p>{{releaseAllJudge[0]}}</p>
					<p>{{releaseAllJudge[1]}}</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        删除-->
		<WxMessageBox :show="delShow" @save="delSave" @canse="delCanse">
			<div slot="content">
				<div class="word marTop">
					<p>你是否确定删除此项，删除后，</p>
					<p>将不可恢复！</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        批量删除-->
		<WxMessageBox :show="delAllShow" @save="delAllSave" @canse="delAllCanse">
			<div slot="content">
				<div class="word marTop">
					<p>您是否确定批量删除已勾选任务？</p>
					<p>删除后，将不可恢复！</p>
				</div>
			</div>
		</WxMessageBox>
		<!--添加任务-->
		<WxMessageBox :show="addTaskShow" @save="addTaskSave" @canse="addTaskCanse">
			<div slot="content">
				<el-form :model="taskForm" :rules="taskRules" ref="taskForm" label-width="0px">
					<div class="import addTask">
						<div class="item">
							<span class="item_label">请选择分区;</span>
							<div class="input">
								<el-form-item label="" prop="area_id">
									<el-select v-model="taskForm.area_id" placeholder="请选择" size="mini"
										@change="changeAllTaskType">
								
										<el-option v-for="item in partition_list" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="item">
					  <span class="item_label">请选择任务类别;</span>
							<div class="input">
								<el-form-item label="" prop="type_id">
									<el-select v-model="taskForm.type_id" placeholder="请选择" size="mini"
										@change="changeAllTaskType">
										<el-option v-for="item in typeList" :key="item.id" :label="item.name"
											:value="item.id">
										</el-option>
					  		</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="item">
							<span class="item_label">请选择任务：</span>
							<div class="input">
								<el-form-item label="" prop="data_task_id">
									<el-select v-model="taskForm.data_task_id" placeholder="请选择" size="mini" filterable>
										<el-option v-for="item in task_list" :key="item.id" :label="item.task_name"
											:value="item.id">
										</el-option>
									</el-select>
								</el-form-item>
							</div>
						</div>
						<div class="item">
							<span class="item_label">请选择执行日期：</span>
							<div class="input">
								<el-form-item label="" prop="display_run_time">
									<el-date-picker v-model="taskForm.display_run_time" type="date" size="mini"
										value-format="yyyy-MM-dd" placeholder="选择日期">
									</el-date-picker>
								</el-form-item>
							</div>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
		<!--        确定弹窗-->
		<WxMessageBox :show="saveShow" @save="Save" @canse="Canse">
			<div slot="content">
				<div class="word">
					<p>您是否确定此次操作？</p>
				</div>
			</div>
		</WxMessageBox>
		<!--        批量安排弹窗-->
		<WxMessageBox :show="personnelShow" @save="personnelSave" @canse="personnelCanse">
			<div slot="content">
				<el-form :model="userForm" :rules="userRules" ref="userForm" label-width="0px">
					<div class="personnel">
						<div class="item_label">请选择人员:</div>
						<div class="radio_box">

							<el-form-item label="" prop="user">
								<el-checkbox-group v-model="userForm.user">
									<el-checkbox :label="item.user_id" v-for="(item,index) in farm_user_list"
										v-if="item.position_code==200 || item.position_code==300" :key="'user'+index">
										{{item.user.nickname}}({{item.position.name}})</el-checkbox>

								</el-checkbox-group>
							</el-form-item>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>

		<!--        批量安排弹窗-->
		<WxMessageBox :show="checkShow" @save="checkSave" @canse="checkCanse">
			<div slot="content">
				<el-form :model="checkForm" :rules="checkRules" ref="checkForm" label-width="0px">
					<div class="personnel">
						<div class="item_label">审核状态:</div>
						<div class="radio_box">

							<el-form-item label="" prop="is_check">
								<el-radio-group v-model="checkForm.is_check">
									<el-radio :label="1">审核通过</el-radio>
									<el-radio :label="3">审核拒绝</el-radio>

								</el-radio-group>

							</el-form-item>
						</div>
					</div>
					<div class="personnel">
				 	<div class="item_label">操作原因:</div>
						<div class="radio_box">

							<el-form-item label="" prop="reason">
								<el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="checkForm.reason">
								</el-input>

							</el-form-item>
						</div>
					</div>
				</el-form>
			</div>
		</WxMessageBox>
		
		<WxMessageBox :show="checkShow" @save="checkSave" @canse="checkCanse">
		    <div slot="content">
				<el-form :model="checkForm" :rules="checkRules" ref="checkForm" label-width="0px">
		        <div class="personnel">
		            <div class="item_label">审核状态:</div>
		            <div class="radio_box">
						
						<el-form-item label="" prop="is_check">
							<el-radio-group v-model="checkForm.is_check">
							    <el-radio :label="1">审核通过</el-radio>
							    <el-radio :label="3">审核拒绝</el-radio>
							  
							  </el-radio-group>
						
						</el-form-item>
		            </div>
		        </div>
				<div class="personnel">
				    <div class="item_label">操作原因:</div>
				    <div class="radio_box">
						
						<el-form-item label="" prop="reason">
							<el-input
							  type="textarea"
							  :rows="2"
							  placeholder="请输入内容"
							  v-model="checkForm.reason">
							</el-input>
						
						</el-form-item>
				    </div>
				</div>
				     </el-form>
		    </div>
		</WxMessageBox>
	</div>
</template>

<script>
	import {
		getFarmWorkTask,
		getAllTask,
		addFarmWorkTask,
		batchOperate,
		batchPlanTask,
		oneKeyMakeTask,
		checkFarmWorkTask
	} from '@/api/api'
	import Comment from '@/components/Comment';
	import WxMessageBox from '@/components/MessageBox';
	export default {
		name: "workTask",
		data() {
			const validateCheck = (rule, value, callback) => {
			                if (this.checkForm["is_check"]==3) {
			                    if(value!=undefined && value!=null && value!=''){
			                        callback()
			                    }else{
			                        callback(new Error('请输入审核拒绝原因'))
			                    }
			                } else {
			                    callback()
			                }
			            }
			return {
				user: [],
				tabShowNum: 100,
				year: new Date().getFullYear().toString(),
				farm_id: '',
				total: 0,
				typeList: [],
				partition_list: [],
				user_position_code: 0,
				crop_list: [],
				tabPage: {
					task_complete_status: '',
					area_id: '',
					type_id: '',
					currentPage: 1, // 初始页
					pagesize: 10, // 每页的数据
				},
				tabZnPage: {
					task_complete_status: '',
					area_id: '',
					type_id: '',
					currentPage: 1, // 初始页
					pagesize: 10, // 每页的数据
				},
				ids: [],
				taskTableData: [],
				zn_total:0,
                taskZnTableData:[],

				task_list: [],
				taskForm: {
					area_id: '',
					type_id: '',
					data_task_id: '',
					display_run_time: '',
					is_publish:2
				},
				taskRules: {
					area_id: [{
						required: true,
						message: '请选择园区分区',
						trigger: 'change'
					}],
					type_id: [{
						required: true,
						message: '请选择任务类别',
						trigger: 'change'
					}],
					data_task_id: [{
						required: true,
						message: '请选择任务',
						trigger: 'change'
					}],
					display_run_time: [{
						required: true,
						message: '请选择任务执行时间',
						trigger: 'change'
					}],
				},
				farm_user_list: [],
				userForm: {
					user: [],
				},
				userRules: {
					user: [{
						required: true,
						message: '必选',
						trigger: 'change'
					}],

				},

				endStateList: [{
					id: 1,
					value: '任务完成'
				}, {
					id: 2,
					value: '任务取消'
				}],




				comment: '',
				checkShow: false,
				checkForm: {
					work_task_id: '',
					is_check: '',
					reason: '',
				},
				checkRules: {
					is_check: [{
						required: true,
						message: '请选择审核状态',
						trigger: 'change'
					}],
					reason: [{
						required: true,
						message: '请输入操作原因',
						trigger: 'blur'
					}],

				},
				// 弹窗
				releaseShow: false,
				releaseAllShow: false,
				releaseAllJudgeShow: false,
				releaseAllJudge: ['对不起，您勾选的任务中，有执行时间', '已经过了的任务，请单独发布！', '对不起，您勾选的任务中，不能同时', '满足分区信息，请单独发布！'],
				delShow: false,
				delAllShow: false,
				addTaskShow: false,
				taskCategory: '',
				taskCategoryOptions: [],
				task: '',
				taskOptions: [],
				executionDate: '',
				personnelShow: false,
				radio: '',
				saveShow: false,
				number: 0,
				zn_number:0,
				checkShow:false,
				checkForm:{
					        work_task_id:'',
					        is_check:'',
						    reason:'',	
							is_zhineng:'',
						   
				},
				checkRules: {
					is_check: [{required: true,message: '请选择审核状态',trigger: 'change'}],
					reason: [{required: true,trigger: 'blur',validator: validateCheck}],
															
				},
			}
		},
		created() {
			this.farm_id = this.$route.params.id
			let tabShowNum=localStorage.getItem("tabShowNum"+this.farm_id)
			 if(tabShowNum==null){
				 
			 }else{
				 this.tabShowNum=tabShowNum
			 }
			
			let json=localStorage.getItem("tabPage"+this.farm_id)
			 if(json===null){
				 
			 }else{
				this.tabPage=eval("("+json+")");
			 }
		let jsonZn=localStorage.getItem("tabZnPage"+this.farm_id)
		 if(jsonZn===null){
			 
		 }else{
			this.tabZnPage=eval("("+jsonZn+")");
		 }
		 let year=localStorage.getItem("year"+this.farm_id)
		  if(year===null){
		 	 
		  }else{
		 	this.year=year
		  }
			console.log("bbb")
			console.log(localStorage.getItem("tabShowNum"+this.farm_id))
			console.log(localStorage.getItem("tabPage"+this.farm_id))
			this.getFarmWorkTask(1)
			this.getZnFarmWorkTask(2)
			
		},
		methods: {

			getZnFarmWorkTask() {

				getFarmWorkTask(this.farm_id, this.year, this.tabShowNum,2,this.tabPage).then(resp => {
					localStorage.setItem("year",this.year)
					this.partition_list = resp.partition_list
				
					this.zn_total = resp.list.total
					this.taskZnTableData = resp.list.data
				
					this.typeList = resp.type
					this.crop_list = resp.crop_list
					this.farm_user_list = resp.user_list
					this.user_position_code = resp.position_code
					this.zn_number++
					if ((this.user_position_code == 150) && (this.zn_number == 1)) {
						this.tabShowNum = 200

						this.getZnFarmWorkTask()
					}
					if ((this.user_position_code == 200) && (this.zn_number == 1)) {
						this.tabShowNum = 100
					
						this.getZnFarmWorkTask()
					}
					if ((this.user_position_code == 100) && (this.zn_number == 1)) {
						this.tabShowNum = 100
					
						this.getZnFarmWorkTask()
					}
				})
			},
			getFarmWorkTask() {
			
				getFarmWorkTask(this.farm_id, this.year, this.tabShowNum,1,this.tabPage).then(resp => {
					localStorage.setItem("year",this.year)
					this.partition_list = resp.partition_list
					this.total = resp.list.total
					this.taskTableData = resp.list.data
					this.typeList = resp.type
					this.crop_list = resp.crop_list
					this.farm_user_list = resp.user_list
					this.user_position_code = resp.position_code
					this.number++
					if ((this.user_position_code == 150) && (this.number == 1)) {
						this.tabShowNum = 200
			             console.log(this.tabShowNum)
						this.getFarmWorkTask()
					}
					if ((this.user_position_code == 200) && (this.number == 1)) {
						this.tabShowNum = 100
					     console.log(this.tabShowNum)
						this.getFarmWorkTask()
					}
					if ((this.user_position_code == 100) && (this.number == 1)) {
						this.tabShowNum = 100
					     console.log(this.tabShowNum)
						this.getFarmWorkTask()
					}
				})
			},
			one_key_task(){
				oneKeyMakeTask(this.farm_id).then(resp=>{
					this.$message.success("一键任务成功");
				})
				
			},
			handleSelectionChange(selection) {
				this.ids = selection.map(item => item.id)

			},
			handleZnSelectionChange(selection) {
				this.ids = selection.map(item => item.id)
			
			},
			planTask(id) {
				this.ids = [],
					this.ids.push(id)
				this.personnelShow = true
			},
			changeTaskTab(val) {
				this.tabShowNum = val
				this.ids = []
				this.tabPage.currentPage = 1
				this.tabZnPage.currentPage = 1
				this.getFarmWorkTask()
				this.getZnFarmWorkTask()
			},
			changeAllTaskType() {
				getAllTask(this.taskForm).then(resp => {
					this.task_list = resp
				})
			},

			handleDelete(id) {
				let param = {
					ids: id
				};
				batchOperate(2, param).then(resp => {
					this.$message.success("删除成功")
					this.getFarmWorkTask()

				})
			},
			handlePublish(id) {
				let param = {
					ids: id,
					farm_id: this.farm_id
				};
				this.$confirm('你确认要发布该任务么?', '提示', {
					confirmButtonText: '确定',
				 cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					batchOperate(1, param).then(resp => {
						this.$message.success("发布成功")
						this.getFarmWorkTask()
					
					}).catch(error => console.log(error))
				
				}).catch(() => {
					this.$message({
						type: 'error',
						message: '已取消'
					});
				});
			
			},
			changeArea() {
				this.getFarmWorkTask()
			},
			changeTaskType() {
				this.getFarmWorkTask()
			},
			changeCrop() {
				this.getFarmWorkTask()
			},
			changeCompleteStatus() {
				this.getFarmWorkTask()
			},
			
			changeZnArea() {
				this.getZnFarmWorkTask()
			},
			changeZnTaskType() {
				this.getZnFarmWorkTask()
			},
			changeZnCrop() {
				this.getZnFarmWorkTask()
			},
			changeZnCompleteStatus() {
				this.getZnFarmWorkTask()
			},
			// 表格斑马纹
			tableRowClassName({
				row,
				rowIndex
			}) {
				if (rowIndex % 2 !== 1) {
					return 'single-row';
				} else {
					return 'double-row';
				}
			},
			// 分页
			handleSizeChange: function(size) {
				this.tabPage.pagesize = size;
				this.getFarmWorkTask()
				//console.log(this.pagesize)  //每页下拉显示数据
			},
			handleCurrentChange: function(currentPage) {
				this.tabPage.currentPage = currentPage;
				this.getFarmWorkTask()
				//console.log(this.currentPage)  //点击第几页
			},
			handleZnSizeChange: function(size) {
				this.tabPage.pagesize = size;
				this.getZnFarmWorkTask()
				//console.log(this.pagesize)  //每页下拉显示数据
			},
			handleZnCurrentChange: function(currentPage) {
				this.tabZnPage.currentPage = currentPage;
				this.getZnFarmWorkTask()
				//console.log(this.currentPage)  //点击第几页
			},
			// 编辑工作任务
			EditWorkTask(id) {
				localStorage.setItem("year"+this.farm_id,this.year)
				localStorage.setItem("tabShowNum"+this.farm_id,this.tabShowNum)
				localStorage.setItem("tabPage"+this.farm_id, JSON.stringify(this.tabPage))
				localStorage.setItem("tabZnPage"+this.farm_id, JSON.stringify(this.tabZnPage))
				this.$router.push('/park/farming/workTask/detail/' + this.farm_id + '/' + id);
			},
            updateWorkTask(id) {
				this.$router.push('/park/farming/workTask/update/' + this.farm_id + '/' + id);
			},
			// 发布弹窗确认
			checkSave() {
				 if(this.ids.length<1){
					 this.$message.error("至少选择一个你要操作的任务")
					 return false;
				 }
				this.$refs["checkForm"].validate((valid) => {
					if (valid) {
						
						let param = {
							ids: this.ids,
							farm_id:this.farm_id,
							form:this.checkForm,
						};
						batchOperate(3, param).then(resp => {
							this.checkShow = false
							this.getFarmWorkTask()
						
						})
						/* checkFarmWorkTask(this.farm_id, this.checkForm).then(resp => {
							this.number = 0
							this.getFarmWorkTask()
							this.checkShow = false
						}).catch(error => console.log(error)) */
					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			// 发布弹窗取消
			checkCanse() {
				this.checkShow = false
			},
			handleCheck(row) {
				console.log(row)
				this.checkForm.work_task_id = row.id
				this.checkForm.is_check = row.is_check
				this.checkShow = true
			},
			// 发布弹窗确认
			releaseSave() {
				this.releaseShow = false
			},
			// 发布弹窗取消
			releaseCanse() {
				this.releaseShow = false
			},
			// 批量发布弹窗确认
			releaseAllSave() {
				let param = {
					ids: this.ids,
					farm_id:this.farm_id
				};
				batchOperate(1, param).then(resp => {
					this.getFarmWorkTask()
					this.releaseAllShow = false

				})

				/* this.$nextTick(()=>{
				     this.releaseAllJudgeShow = true
				 }) */
			},
			// 批量发布弹窗取消
			releaseAllCanse() {
				this.releaseAllShow = false
			},
			// 批量发布判断弹窗确认
			releaseAllJudgeSave() {
				this.releaseAllJudgeShow = false
			},
			// 批量发布判断弹窗取消
			releaseAllJudgeCanse() {
				this.releaseAllJudgeShow = false
			},
			// 删除弹窗确认
			delSave() {
				let param = {
					ids: this.ids,
					farm_id:this.farm_id
				};
				batchOperate(2, param).then(resp => {
					this.delShow = false
					this.getFarmWorkTask()

				})

			},
			// 删除弹窗取消
			delCanse() {
				this.delShow = false
			},
			// 批量删除弹窗确认
			delAllSave() {
				let param = {
					ids: this.ids,
					farm_id:this.farm_id
				};
				batchOperate(2, param).then(resp => {
					this.delAllShow = false
					this.getFarmWorkTask()

				})
			},
			// 批量删除弹窗取消
			delAllCanse() {
				this.delAllShow = false
			},
			// 添加任务弹窗确认
			addTaskSave() {

				this.$refs["taskForm"].validate((valid) => {
					if (valid) {
						addFarmWorkTask(this.$route.params.id, this.year, this.taskForm).then(resp => {
							this.getFarmWorkTask()
							this.addTaskShow = false
							this.clearTaskForm()
						}).catch(error => console.log(error))
					} else {
						console.log(this.taskForm)
						console.log('error submit!!');
						return false;
					}
				});
			},
			// 添加任务弹窗取消
			addTaskCanse() {
				this.clearTaskForm()
				this.addTaskShow = false
			},
			
			clearTaskForm(){
				this.taskForm["area_id"]=''
				this.taskForm["type_id"]=''
				this.taskForm["data_task_id"]=''
				this.taskForm["display_run_time"]=''
				
			},
			// 批量人员安排弹窗确认
			personnelSave() {
				let param = {
					ids: this.ids,
					user: this.userForm.user
				}
				this.$refs["userForm"].validate((valid) => {
					if (valid) {
						this.$confirm('您是否确定此次操作?', '提示', {
							confirmButtonText: '确定',
						 cancelButtonText: '取消',
							type: 'warning'
						}).then(() => {
							batchPlanTask(param).then(resp => {
								this.getFarmWorkTask()
								this.personnelShow = false
							}).catch(error => console.log(error))

						}).catch(() => {
							this.$message({
								type: 'error',
								message: '已取消'
							});
						});

					} else {
						console.log('error submit!!');
						return false;
					}
				});

			},
			// 批量人员安排弹窗取消
			personnelCanse() {
				this.ids = [],
					this.personnelShow = false
			},
			// 确认弹窗确认
			Save() {
				this.saveShow = false
			},
			// 确认弹窗取消
			Canse() {
				this.saveShow = false
			},
		},
		components: {
			Comment,
			WxMessageBox
		}
	}
</script>

<style lang="less">
	.workTask {
		.select_year {
			margin-top: 25px;
			display: flex;
			align-items: center;

			.label {
				width: 99px;
				font-size: 16px;
				color: #91AFBA;
			}

			.el-input__inner {
				text-align: center;
			}
		}

		.tabs {
			display: flex;
			margin-top: 23px;

			span {
				width: 150px;
				height: 30px;
				border: 1px solid #2B92F6;
				line-height: 30px;
				font-size: 14px;
				color: #fff;
				text-align: center;
				cursor: pointer;
			}

			.active {
				background: #2B92F6;
				color: #fff;
			}
		}

		.tabTop {
			margin-top: 30px;
			display: flex;
			justify-content: space-between;
			align-items: center;
			.subTitle {
				font-size: 16px;
				color: #10FFCA;
				padding-top: 20px;
			}
			.select_box {
				.el-select {
					width: 160px;

					&+.el-select {
						margin-left: 20px;
					}
				}
			}

			.btn_box {
				.el-button {
					width: 134px;
					height: 40px;
					background: #00A1E6;
					line-height: 40px;
					font-size: 18px;
					color: #FFFFFF;
					border-radius: 0;
					padding: 0;
					border: 0;
				}
			}
		}

		.wx_table {
			margin-top: 30px;
		}

		.transparent_tab {
			margin-top: 30px;

			tr {
				&:first-child {
					background-color: transparent;
				}
			}

			th {
				&:first-child {
					background-color: transparent;
					border-left: 0;
				}
			}
		}

		.pagination {
			.pagination_btn {
				.el-button {
					width: 134px;
					height: 40px;
					line-height: 40px;
					border: 1px solid #2D99FF;
					border-radius: 0;
					background-color: transparent;
					font-size: 18px;
					font-weight: 400;
					color: #2D99FF;
					padding: 0;
				}
			}
		}

		.disFlex {
			display: flex;
			justify-content: space-between;
		}

		.margTop {
			margin-top: 35px;
		}

		.comment {
			margin-top: 35px;
			display: flex;

			.userImg {
				width: 80px;
				height: 80px;
				border: 1px solid #979797;
				margin-right: 20px;
				text-align: center;

				img {
					width: 100%;
				}
			}
		}

		.comment_btn {
			width: 100%;
			margin-top: 20px;
			border-bottom: 2px solid rgba(43, 148, 249, 0.2);
			padding-bottom: 40px;
			overflow: hidden;

			.el-button {
				float: right;
				width: 200px;
				height: 48px;
				line-height: 48px;
				background: #00A1E6;
				font-size: 18px;
				color: #FFFFFF;
				padding: 0;
				border: 0;
				border-radius: 0;
			}
		}

		.comment_list {
			overflow: hidden;
			padding-top: 25px;

			.title {
				font-size: 20px;
				font-weight: bold;
				color: #fff;
			}

			.item {
				margin-top: 40px;

				.item_left {
					float: left;

					img {
						width: 80px;
						height: 80px;
					}
				}

				.item_right {
					margin-left: 100px;

					.name {
						font-size: 20px;
						font-weight: bold;
						color: #00A1E6;
						padding-bottom: 10px;
					}

					p {
						font-size: 20px;
						color: #DDDDDD;
						line-height: 28px;
					}

					.bottom {
						padding-top: 10px;
						display: flex;
						justify-content: space-between;
						align-items: center;

						.time {
							font-size: 20px;
							color: #9B9B9B;
						}

						.btns {
							display: flex;

							.btn {
								font-size: 20px;
								color: #ddd;
								display: flex;
								align-items: center;
								cursor: pointer;

								img {
									margin-right: 15px;
								}
							}

							.reply_btn {
								margin-right: 80px;
							}
						}
					}

					.child {
						margin-top: 20px;
						background: rgba(0, 161, 230, 0.1206);
						border-radius: 1px;
						overflow: hidden;
						padding: 22px 10px 26px 21px;

						.sub_item {
							margin-bottom: 22px;
							padding-bottom: 25px;
							border-bottom: 1px solid rgba(0, 161, 230, 0.2716);

							.item_left {
								img {
									width: 60px;
									height: 60px;
								}
							}
						}

						.sub_lenth {
							font-size: 20px;
							color: #00A1E6;
							cursor: pointer;
						}
					}

				}
			}
		}
	}
</style>
